import React from 'react';
import Sidebar from '../../Components/Sidebar/Sidebar';
import Header from '../../Components/Header/Header';
import DashboardRightSection from '../../Components/DashboardRightSection/DashboardRightSection';
import MyBallots from '../../Components/MyBallots/MyBallots';
import ScrollNav from '../../Components/ScrollNav/ScrollNav';
import Chatbot from '../../Components/Chatbot/Chatbot';

const MyBallotsPage = () => {
    return (
        <div className="BallotsPage">
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        <MyBallots />
                    </div>
                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection />
                    </div>
                </div>
                <Chatbot />
                <ScrollNav />
            </div>
        </div>
    )
}

export default MyBallotsPage;
